import React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

const getHostname = (url) => {
  return new URL(url).hostname;
};

const PassageSource = ({ className, passageSource }) => {
  if (!passageSource) {
    return null;
  }

  const source = /^http/.test(passageSource) ? (
    <a href={passageSource} target="_blank" rel="noopener noreferrer">
      {getHostname(passageSource)} <i className="fad fa-external-link" />
    </a>
  ) : (
    passageSource
  );

  return (
    <div className={classnames(styles.passageSource, className)}>Source: {source}</div>
  );
};

export default PassageSource;
